const footerLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Craft', href: '#craft' },
  { label: 'Contact', href: '#contact' },
  { label: 'Privacy Policy', href: '#privacy' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-goblet-line text-lg"></i>
              </span>
              <span className="font-heading font-semibold tracking-[0.18em] text-sm text-background-50">
                23 BOTTLES OF BEER LLC
              </span>
            </div>
            <p className="mt-4 text-sm text-background-100/70">
              Craft Brewing &bull; Windsor, California
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm tracking-[0.2em] uppercase text-background-50 mb-4">
              Contact
            </h4>
            <ul className="space-y-3 text-sm text-background-100/80">
              <li>
                <a
                  href="mailto:vinnie@23bottlesofbeer.com"
                  className="hover:text-primary-300 transition-colors"
                >
                  vinnie@23bottlesofbeer.com
                </a>
              </li>
              <li>
                <a href="tel:+17075753203" className="hover:text-primary-300 transition-colors">
                  (707) 575-3203
                </a>
              </li>
              <li className="leading-relaxed">
                700 Mitchell Ln<br />
                Windsor, CA 95492-6902<br />
                United States
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm tracking-[0.2em] uppercase text-background-50 mb-4">
              Explore
            </h4>
            <ul className="space-y-3 text-sm">
              {footerLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-background-100/80 hover:text-primary-300 transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-100/60">
            &copy; 2026 23 Bottles of Beer LLC. All rights reserved.
          </p>
          <p className="text-xs text-background-100/50">Independent Craft Brewing</p>
        </div>
      </div>
    </footer>
  );
}